import React from 'react';
import PropTypes from 'prop-types';

import styles from './common.less';

export default class SquareBox extends React.Component {
  render() {
    const { width, height, margin, textAlign, padding } = this.props;

    return (
      <div
        style={{
          textAlign,
          padding,
          margin,
          lineHeight: '0',
        }}
      >
        <div
          style={{
            height,
            width,
          }}
          className={styles.withLoadAnimation}
        />
      </div>
    );
  }
}

SquareBox.defaultProps = {
  height: null,
  width: null,
  margin: '0',
  padding: '0',
  textAlign: 'left',
};

SquareBox.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  textAlign: PropTypes.string,
};
